const DaysOfMonthData = () => {
    const data = []

    for (let i = 1; i <= 31; i++) {
        data.push({ value: i.toString(), label: i });
    }

    return data
}

export default DaysOfMonthData